<style type="text/css">
  .ngx-file-drop__drop-zone {
    border: none;
  }
</style>
<div class="row" *ngIf="attachmentConfigs">
  <div class="col-12">
    <legend
      class="border-bottom"
      [innerText]="'Attachments' | translate"
    ></legend>
  </div>
</div>

<div class="row" *ngIf="attachmentConfigs">
  <div class="col-12">
    <ul class="list-group ds-list-group-default">
      <li
        class="list-group-item ds-list-group-head-default d-flex justify-content-start align-items-center px-2"
      >
        <app-detail-display class="w-mm-40" key="trAttachmentName">
        </app-detail-display>
        <app-detail-display class="w-mm-40" key="trAttachmentFileName">
        </app-detail-display>
      </li>
      <li
        *ngFor="let config of attachmentConfigs"
        class="list-group-item d-flex justify-content-start align-items-center"
      >
        <div class="ds-list-group-item-head d-flex w-100 p-2">
          <div class="w-mm-40">
            <div class="detail-group">
              <div class="detail-text">
                <p>
                  {{ isArabic ? config.nameAr : config.nameEn }}
                  <span *ngIf="config.isRequired" class="text-danger"> *</span>
                </p>
              </div>
            </div>
          </div>
          <div class="w-mm-40">
            <div class="detail-group">
              <div
                class="detail-text"
                *ngIf="hasAttachment(config.procedureAttachmentId); else noAttachment"
              >
                <a class="link" (click)="downloadFile(config.procedureAttachmentId)">
                  <p>{{ hasAttachment(config.procedureAttachmentId)?.attachmentFileName }}</p>
                </a>
              </div>
              <div
                class="detail-text text-danger is-invalid"
                *ngIf="config.invalidFileExtension || config.invalidFileSize"
              >
                <p *ngIf="config.invalidFileExtension">
                  {{ 'Invalid File Extension' | translate }}
                </p>
                <p *ngIf="config.invalidFileSize">
                  {{ 'Exceed Maximum File Size' | translate }}
                </p>
                <p
                  *ngIf="
                    !config.invalidFileExtension && !config.invalidFileSize
                  "
                >
                  {{ 'Please Upload File' | translate }}
                </p>
              </div>
            </div>
          </div>
          <div>
            <ngx-file-drop
              dropZoneClassName=""
              contentClassName=""
              [accept]="allowedExtensions"
              [multiple]="false"
              (onFileDrop)="onFileDrop($event, config)"
            >
              <ng-template
                ngx-file-drop-content-tmp
                let-openFileSelector="openFileSelector"
              >
                <div class="justify-content-center">
                  <div class="list-group-item-options">
                    <a
                      class="ds-btn-icon"
                      title="{{ 'UploadFile' | translate }}"
                      (click)="openFileSelector()"
                    >
                      <i class="icon-upload" style="font-size: 20px"></i>
                    </a>
                    <a
                      *ngIf="hasAttachment(config.procedureAttachmentId)"
                      class="ds-btn-icon"
                      title="{{ 'Delete' | translate }}"
                      (click)="deleteAttachment(config.procedureAttachmentId)"
                    >
                      <i class="fi-close"></i>
                    </a>
                    <!-- <a *ngIf="hasAttachment(config.procedureAttachmentId)" 
                          class="ds-btn-icon" 
                          title="{{'trViewFile'|translate}}"
                          (click)="downloadFile(config.procedureAttachmentId)">
                        <i class="fi-view" style="font-size: 20px;"></i>
                      </a> -->
                  </div>
                </div>
              </ng-template>
            </ngx-file-drop>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

<ng-template #noAttachment>
  <p>{{ 'No File Uploaded' | translate }}</p>
</ng-template>
